import React, { useRef, useState, useEffect } from "react";
import {
  Button,
  Grid,
  DialogActions,
  DialogContent,
  // TextField,
  Box,
  Modal,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import ExcelIcon from "./../../Assests/excel.svg";
import CancelIcon from "@mui/icons-material/Close";
import DownloadIcon from "./../../Assests/download.svg";
import InfoIcon from "@mui/icons-material/Info";
import CancelIconRed from "./../../Assests/cancel.svg";
import UploadingMasterFile from "./UploadingMasterFile";
import {
  handleTemplateCOGDownLoadByType,
  COGTemplateDownload,
  // handleTemplateDownLoadByTypeMedium,
} from "../../Redux/Actions/InputData";
import { useDispatch, useSelector } from "react-redux";
import {
  API_BASE_URL,
  COG_EXCEL_FILE_UPLOAD_API,
  // GET_CGO_SAS_URI_API,
} from "../../Utils/Config";
// import { getRequest } from "../../Services/AxiosConfiguration";
import * as actions from "./../../Redux/Actions/index";
import ToastPopup from "../ToastPopup";
import axios from "axios";
import { ActivateOrDeactivateFolder } from "../../Services/FolderService";

function CGOUploadMasterData(props: any) {
  const {
    isUploadMasterFile,
    selectRadio,
    handleOpenBaseLineUploader,
    isUploadScenarioData,
    handleGoBack,
    selectLine,
    newScenarioId,
    newFolderId,
    handleClose,
    selectedFolderId,
    selectedScenarioId,
  } = props;
  console.log(selectedFolderId, "selected Fodler ID");
  const dispatch: any = useDispatch();

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const isLoading = useSelector(
    (state: any) => state.InputDataReducers.isLoading,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );
  const isUploadFileDone = useSelector(
    (state: any) => state.InputDataReducers.isDone,
  );

  useEffect(() => {
    props.setModalTitleText("Upload COG Data");
    return () => {
      props.setModalTitleText("COG Opening Form");
    };
  }, []);

  useEffect(() => {
    if (isUploadFileDone) {
      setIsUpload(true);
    }
  }, [isUploadFileDone]);

  const getDataYes: any = [
    {
      id: 1,
      name: "Upload COG File",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const getDataNo: any = [
    {
      id: 1,
      name: "Upload COG File",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const getData = selectLine === "true" ? getDataYes : getDataNo;
  const [getMasterData, setGetMasterData] = useState(getData);
  const [selectedItemId, setSelectedItemId] = useState<any>("");
  const [selectedfileList, setSelectedFileList] = useState<any>([]);
  const [selectedfilesList, setSelectedFilesList] = useState<any>([]);
  const [selectedfile, setSelectedFile] = useState<any>({});
  const [isUpload, setIsUpload] = useState<any>(false);

  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData,
  );
  // COG new run template download
  const handleTemplateDownLoad = () => {
    let fileName =
      selectLine === "true"
        ? "COGExistingPlants_Template"
        : "COGWithoutExistingPlant_Template";
    const type = selectLine === "true" ? 1 : 2;

    handleTemplateCOGDownLoadByType(type, fileName);
  };

  // COG re run template download
  const reRunTemplateDownLoad = () => {
    COGTemplateDownload(selectedFolderId, selectedScenarioId);
  };

  useEffect(() => {
    setSelectedFileList([]);
    //callFolderFilterApi();
  }, []);

  const handleUploadFile = (e: any, item: any, index: number) => {
    e.preventDefault();
    getMasterData[index]?.ref.current.click();
    clearInterval(getMasterData[index].ref.current);
    setSelectedItemId(item.id);
  };

  const handleChangeFileUpload = (e: any) => {
    selectedfileList.length = 0;
    const fileUploaded = e.target.files[0];
    selectedfileList.push(fileUploaded.name);
    selectedfilesList.push({
      filename: fileUploaded.name,
      filedata: fileUploaded,
    });
    if (!fileUploaded) {
      return;
    }
    const newArr = getMasterData.map((ele: any, i: any) => {
      if (selectedItemId === ele.id) {
        ele.selectedFile = fileUploaded;
      }
      return ele;
    });
    setGetMasterData(newArr);
    setSelectedFile(fileUploaded);
  };
  const [uploadSuccessMessage, setUploadSuccessMessage] = useState("");
  const handleUploadNow = (e: any, runType: string) => {
    e.preventDefault();
    let formData = new FormData();
    getMasterData.map((itm: any) => {
      if (itm.selectedFile.name) {
        formData.append("files", itm.selectedFile);
      }
    });
    const fileType = selectLine === "true" ? 1 : 2;
    let filesList = selectedfilesList;
    console.log(selectedFolderId, newFolderId, "selectedFolderId112");
    let initialValues = {
      folder: selectedFolderId || newFolderId,
      scenario: selectedScenarioId || newScenarioId,
    };
    // setUploadSuccessMessage("Files Successfully Uploaded");
    dispatch(
      actions.onInitUloadMasterFile(
        formData,
        filesList,
        fileType,
        initialValues,
        "type",
        "",
        "COG",
        runType,
        userData.userId,
      ),
    );
    // setIsUpload(true);
    setSelectedFilesList([]);
  };

  const [isUploadNowSuccess, setIsUploadNowSuccess] = useState(false);
  const handleDoneUpload = (status: any) => {
    if (status === 200) {
      props.handleClose();
      setIsUploadNowSuccess(true);
      setTimeout(() => {
        setIsUploadNowSuccess(false);
      }, 3000);
    }
  };
  const handleCancelFile = (e: any, elem: any) => {
    const newArr = getMasterData?.filter((ele: any, i: any) => {
      if (ele.id === elem.id) {
        ele.selectedFile = {};
      }
      return ele;
    });
    setGetMasterData(newArr);
  };

  const handleReRunDialog = () => {
    setIsUpload(false);
    handleFileUploadApi();
    setLongTermExcelStatus(true);
  };

  const [rerunUploadStatusData, setRerunUploadStatusData] = useState<any>([]);
  const [longTermExcelStatus, setLongTermExcelStatus] = useState<any>(false);
  const [intervalId, setIntervalId] = useState<any>(null);
  const [openReRunDialogStatus, setOpenReRunDialogStatus] = useState<any>("");
  var dataLength = 0;
  let failedCount = 0;
  let successCount = 0;
  const [progressBarStatus, setProgressBarStatus] = useState<any>(false);
  const [failedStatus, setFailedStatus] = useState<any>(false);
  const [successStatus, setSuccessStatus] = useState<any>(false);
  const handleFileUploadApi = () => {
    const urls = API_BASE_URL + COG_EXCEL_FILE_UPLOAD_API;

    const requestParam = {
      folder_Id: props?.selctedFolderId || newFolderId,
      scenario_Id: Number(newScenarioId),
    };
    const apicallInterval = setInterval(() => {
      handleOpenApicall(urls, requestParam);
    }, 20000);
    setIntervalId(apicallInterval);
    // clearInterval(intervalId);
  };

  const handleOpenApicall = (urls: any, requestParam: any) => {
    axios({
      url: urls,
      method: "post",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response: any) => {
      if (response.status === 200) {
        setRerunUploadStatusData(response.data);
        setProgressBarStatus(true);
        let rerunData = response.data;
        {
          rerunData?.map((item: any) => {
            if (item?.status.toLowerCase().includes("failed")) {
              setOpenReRunDialogStatus(item?.errorMessage);
              failedCount = failedCount + 1;
            } else if (item?.status.toLowerCase().includes("success")) {
              setOpenReRunDialogStatus(item?.status);
              successCount = successCount + 1;
            }
          });
        }
        if (response.data[1].status === "Gurobi Successfully Completed") {
          setSuccessStatus(true);
          setProgressBarStatus(false);
        }
        if (failedCount > 0) {
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
          ActivateOrDeactivateFolder(selectedUsecaseId, selectedFolderId, 0);
          setProgressBarStatus(false);
          setFailedStatus(true);
        }
        if (response?.data?.length === successCount) {
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
          setProgressBarStatus(false);
          //setFailedStatus(true);
        }
      }
    });
  };

  const handleCloseExcelPopup = () => {
    setLongTermExcelStatus(false);
    localStorage.setItem("selectCGOInput", "CGOInput");
    window.location.href = "/CGOHome";
    setFailedStatus(false);
    setSuccessStatus(false);
  };

  return (
    <>
      {longTermExcelStatus && (
        <Modal
          open={longTermExcelStatus}
          onClose={handleCloseExcelPopup}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          className="done-modal"
          // ref={modelRef}
          // onClick={handleBackDropClick}
        >
          <>
            <DialogContent data-keyboard="false" data-backdrop="static">
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 600,
                  bgcolor: "background.paper",
                  border: "2px solid #000",
                  boxShadow: 24,
                  p: 2,
                  height: 400,
                  overflowY: "auto",
                }}
              >
                <Box>
                  <p>
                    {(failedStatus || successStatus) && (
                      <>
                        <CancelIcon
                          className="cancel-icon"
                          onClick={handleCloseExcelPopup}
                        />
                      </>
                    )}
                  </p>
                  {progressBarStatus && (
                    <Box>
                      <div
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    </Box>
                  )}

                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>File Name</TableCell>
                          <TableCell>File Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rerunUploadStatusData?.map((item: any) => (
                          <TableRow>
                            <TableCell>{item.fileName}</TableCell>
                            <TableCell>{item.status}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                {openReRunDialogStatus
                  ?.toLowerCase()
                  ?.includes("successfully") ? (
                  <>
                    <h6>{openReRunDialogStatus}</h6>
                    <br />
                  </>
                ) : !openReRunDialogStatus
                    ?.toLowerCase()
                    ?.includes("failed") ? (
                  <>
                    <h6 className="error-modal-message">
                      {openReRunDialogStatus}
                    </h6>
                    <br />
                  </>
                ) : (
                  <></>
                )}

                <div style={{ alignItems: "center", textAlign: "center" }}>
                  {/* <Button onClick={handleReRunDialogStatus}>Close</Button> */}
                </div>
              </Box>
            </DialogContent>
          </>
        </Modal>
      )}
      {/* Is uploaded successfully modal */}
      {isUpload && (
        <Modal
          open={isUpload}
          onClose={handleReRunDialog}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
            }}
          >
            <h2
              style={{ alignItems: "center", textAlign: "center" }}
              id="modal-title"
            >
              Files Uploaded Successfully!
            </h2>
            <div style={{ alignItems: "center", textAlign: "center" }}>
              <Button onClick={handleReRunDialog}>Close</Button>
            </div>
          </Box>
        </Modal>
      )}
      {isUploadMasterFile ? (
        <UploadingMasterFile
          // getData={getData}
          handleCancelFile={handleCancelFile}
          handleOpenBaseLineUploader={handleOpenBaseLineUploader}
          handleCloseDonePopup={props.handleCloseDonePopup}
        />
      ) : props.selectRadio === "masterData" ? (
        <>
          <DialogContent className="modal-body">
            <div className="upload-file-button">
              {getMasterData &&
                getMasterData?.map((ele: any, index: any) => {
                  return (
                    <Grid
                      container
                      spacing={1}
                      key={index}
                      className="uploadFile"
                    >
                      {isUploadNowSuccess && (
                        <ToastPopup
                          message={"Files Uploaded Successfully"}
                          type="success"
                        />
                      )}
                      <Grid item xs={7} md={7} lg={7}>
                        <span>
                          {index + 1}
                          {". "}
                        </span>
                        <span> {ele.name}</span>
                      </Grid>
                      <Grid item xs={5} md={5} lg={5}>
                        <>
                          {ele.selectedFile &&
                          ele.selectedFile?.name?.length > 0 ? (
                            <div className="seletcedFilename">
                              <img src={ExcelIcon} alt="" />{" "}
                              <span> {ele.selectedFile?.name}</span>{" "}
                              <span
                                className="cancel-file"
                                onClick={(e) => handleCancelFile(e, ele)}
                              >
                                <img src={CancelIconRed} alt="" />
                              </span>
                            </div>
                          ) : (
                            <>
                              <Button
                                variant="outlined"
                                className="uploadBtn"
                                onClick={(e) => handleUploadFile(e, ele, index)}
                              >
                                <img src={ExcelIcon} alt="ExcelIcon" />
                                {ele.btnName}
                              </Button>
                              <input
                                type="file"
                                id={"prefix_" + index}
                                ref={ele.ref}
                                style={{ display: "none" }}
                                multiple
                                onChange={(e) => handleChangeFileUpload(e)}
                              />
                            </>
                          )}
                        </>
                      </Grid>
                    </Grid>
                  );
                })}
            </div>
            <div className="download-templet" onClick={handleTemplateDownLoad}>
              <a>
                <img src={ExcelIcon} alt="" /> <span> Download template </span>{" "}
                <img src={DownloadIcon} alt="" />
              </a>
              <p>Download the file with multiple sheets.</p>
            </div>
            {/* <div className="note-area-upload">
              <div className="note">
                <InfoIcon className="noteinfoicon" />
                <span>Note</span>
              </div>
              <div className="note-upload-content">
                <p>
                  All validations must pass only then the data will be loaded.
                </p>
                <p>File must be lesser than 100 MB.</p>
                <p>Only excel files are supported</p>
              </div>
            </div> */}
            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={props.handleGoBack}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  className="Next"
                  onClick={(e) => handleUploadNow(e, "newrun")}
                  disabled={selectRadio == 0 || isLoading}
                  startIcon={
                    isLoading ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : null
                  }
                >
                  {isLoading ? "Uploading..." : "Upload Now"}
                </Button>
              </div>
            </DialogActions>
            <h4 style={{ color: "green" }}>{uploadSuccessMessage}</h4>
          </DialogContent>
        </>
      ) : (
        <>
          <DialogContent className="modal-body">
            <div className="upload-file-button">
              {getMasterData &&
                getMasterData?.map((ele: any, index: any) => {
                  return (
                    <Grid
                      container
                      spacing={1}
                      key={index}
                      className="uploadFile"
                    >
                      {isUploadNowSuccess && (
                        <ToastPopup
                          message={"Files Uploaded Successfully"}
                          type="success"
                        />
                      )}
                      <Grid item xs={7} md={7} lg={7}>
                        <span>
                          {index + 1}
                          {". "}
                        </span>
                        <span> {ele.name}</span>
                      </Grid>
                      <Grid item xs={5} md={5} lg={5}>
                        <>
                          {ele.selectedFile &&
                          ele.selectedFile?.name?.length > 0 ? (
                            <div className="seletcedFilename">
                              <img src={ExcelIcon} alt="" />{" "}
                              <span> {ele.selectedFile?.name}</span>{" "}
                              <span
                                className="cancel-file"
                                onClick={(e) => handleCancelFile(e, ele)}
                              >
                                <img src={CancelIconRed} alt="" />
                              </span>
                            </div>
                          ) : (
                            <>
                              <Button
                                variant="outlined"
                                className="uploadBtn"
                                onClick={(e) => handleUploadFile(e, ele, index)}
                              >
                                <img src={ExcelIcon} alt="ExcelIcon" />
                                {ele.btnName}
                              </Button>
                              <input
                                type="file"
                                id={"prefix_" + index}
                                ref={ele.ref}
                                style={{ display: "none" }}
                                multiple
                                onChange={(e) => handleChangeFileUpload(e)}
                              />
                            </>
                          )}
                        </>
                      </Grid>
                    </Grid>
                  );
                })}
            </div>
            <div className="download-templet" onClick={reRunTemplateDownLoad}>
              <a>
                <img src={ExcelIcon} alt="" /> <span> Download template </span>{" "}
                <img src={DownloadIcon} alt="" />
              </a>
              <p>Download the file with multiple sheets and data.</p>
            </div>
            {/* <div className="note-area-upload">
              <div className="note">
                <InfoIcon className="noteinfoicon" />
                <span>Note</span>
              </div>
              <div className="note-upload-content">
                <p>
                  All validations must pass only then the data will be loaded.
                </p>
                <p>File must be lesser than 100 MB.</p>
                <p>Only excel files are supported</p>
              </div>
            </div> */}
            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={props.handleGoBack}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  className="Next"
                  onClick={(e) => handleUploadNow(e, "rerun")}
                  disabled={isLoading}
                  startIcon={
                    isLoading ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : null
                  }
                >
                  {isLoading ? "Uploading..." : "Upload Now"}
                </Button>
              </div>
            </DialogActions>
            <h4 style={{ color: "green" }}>{uploadSuccessMessage}</h4>
          </DialogContent>
        </>
      )}
    </>
  );
}

export default CGOUploadMasterData;
